import { breakpointsVuetify } from '@vueuse/core'
import {
  AppContentLayoutNav,
  ContentWidth,
  FooterType,
  NavbarType,
} from '@layouts/enums'
import { h, ref } from 'vue'
import {
  getWhiteLabelPortalLogo,
  isBionicSite
} from '@/utils/whiteLabelHelpers'

export const config = {
  app: {
    title: 'Title',
    logo: h('img', { src: `${getWhiteLabelPortalLogo()}` }),
    logoMini: h('img', {
      src: isBionicSite() ? `${getWhiteLabelPortalLogo()}` : '/lightening-bolt-only-logo.gif',
      style: 'height: 30px; margin-left: 15px',
    }),
    // logo: () => h('img', { src: 'assets/colored-logo.png' }, null),
    contentWidth: ref(ContentWidth.Boxed),
    contentLayoutNav: ref(AppContentLayoutNav.Vertical),
    overlayNavFromBreakpoint: breakpointsVuetify.md,
    enableI18n: true,
    isRtl: ref(false),
  },
  navbar: {
    type: ref(NavbarType.Sticky),
    navbarBlur: ref(true),
  },
  footer: { type: ref(FooterType.Static) },
  verticalNav: {
    isVerticalNavCollapsed: ref(false),
    defaultNavItemIconProps: { icon: 'tabler-circle' },
  },
  horizontalNav: {
    type: ref('sticky'),
  },
  icons: {
    chevronDown: { icon: 'tabler-chevron-down' },
    chevronRight: { icon: 'tabler-chevron-right' },
    close: { icon: 'tabler-x' },
    verticalNavPinned: { icon: 'tabler-circle-dot' },
    verticalNavUnPinned: { icon: 'tabler-circle' },
    sectionTitlePlaceholder: { icon: 'tabler-minus' },
  },
}
